import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=ba6ef998&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=ba6ef998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6ef998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba6ef998')) {
      api.createRecord('ba6ef998', component.options)
    } else {
      api.reload('ba6ef998', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=ba6ef998&scoped=true&", function () {
      api.rerender('ba6ef998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4u3g1VRDfEo11/JS/comp/DocBox.vue"
export default component.exports